import { render, staticRenderFns } from "./CampoMonetario.vue?vue&type=template&id=78cf977a"
import script from "./CampoMonetario.vue?vue&type=script&lang=js"
export * from "./CampoMonetario.vue?vue&type=script&lang=js"
import style0 from "./CampoMonetario.vue?vue&type=style&index=0&id=78cf977a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports